import React from 'react'
import classNames from 'classnames'
import SchemaTag from '../SchemaTag.jsx'
import { object, string, array, number, bool } from 'prop-types'

class ProductReviews extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      active: 0
    }
  }

  /* componentDidMount( ) {
    this.update( );
  },

  componentDidUpdate( ) {
    this.update( );
  }

  update( ) {
    const { maxReviews } = this.props;
    let { active } = this.state;
    if ( ++active >= maxReviews ) active = 0;
    setInterval( ( ) => {
      this.setState({
        active
      });
    }, 2000);
  } */

  changeReview (active) {
    this.setState({
      active
    })
  }
  createReviewsPage (key) {
    const { pageData } = this.props
    const productCode = pageData.shortTitle
    const productLocation = pageData.productClass && pageData.productClass === 'HO' ? 'hotelLocations' : 'parkingLocations'
    try {
      const data = require('../../../../../config/exports/buildTimeOnly/' + productLocation + '/' + key + '.json')
      if (!data || !data[productCode] || !data[productCode].links || !data[productCode].links['reviews']) return
      return data[productCode].links['reviews']
    } catch (e) {
      return
    }
  }

  getReviews () {
    const { productData, maxReviews } = this.props
    const { active } = this.state
    const productName = this.getProductName()

    return productData.reviews.reviews.slice(0, maxReviews).reduce((reviews, item, key) => {
      if (!item.comment) return reviews
      const activeClass = classNames({
        'item': true,
        'hidden': active !== key
      })
      // Temporary patch to prevent non-utf-8 symbols from appearing.
      // See: https://holidayextras.jira.com/browse/APP-1027
      item.comment = item.comment.replace(/â€™/, '\'')
      item.comment = item.comment.replace(/ ðŸ˜Š/, '')
      const review = (
        <div key={key} className={activeClass}>
          <blockquote className='comment'>
            <p><span>{ item.comment }</span></p>
            <small>
              <span className='productName'>{ item.name }</span>
              <span> ({ productName })</span>
            </small>
          </blockquote>
        </div>
      )
      reviews.push(review)
      return reviews
    }, [ ])
  }

  getReviewDots () {
    const { productData, maxReviews } = this.props
    const { active } = this.state

    return productData.reviews.reviews.slice(0, maxReviews).reduce((reviews, item, key) => {
      if (!item.comment) return reviews
      const activeClass = classNames({
        'paginate-item': true,
        'active': active === key
      })
      const dot = (
        <li key={key} className={activeClass} onClick={this.changeReview.bind(this, key)} />
      )
      reviews.push(dot)
      return reviews
    }, [ ])
  }

  getProductName () {
    const { productData = {}, functionParams } = this.props
    return (functionParams[1] || productData._base_name || productData.name).replace(/\b\w/g, l => l.toUpperCase())
  }

  render () {
    const { productData, id, noSchemaMarkup } = this.props

    if (!productData || !productData.reviews || !productData.reviews.reviews) return null
    const productName = this.getProductName()
    const reviews = this.getReviews()
    const reviewDots = this.getReviewDots()
    const reviewsLink = this.createReviewsPage(productData._airport)

    return (
      <div id={id} className='contentReviews'>
        <div className='carousel-reviews'>{ reviews }</div>
        <ol className='carousel-indicators'>{ reviewDots }</ol>
        <SchemaTag tagType='p' noSchemaMarkup={noSchemaMarkup} itemScope itemProp='aggregateRating' itemType='http://schema.org/AggregateRating'>
          <strong>
            Our customers rated <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} className='fn' itemProp='itemreviewed'>{ productName } </SchemaTag>
            <span> on average </span>
            <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} className='priceSmall' itemProp='ratingValue'>{ Math.round(productData.reviews.meta.average * 2) }/10</SchemaTag> (
            <SchemaTag tagType='span' noSchemaMarkup={noSchemaMarkup} className='priceSmall' itemProp='ratingCount'>{ productData.reviews.meta.reviewed }</SchemaTag> reviews).
            {reviewsLink && (
              <span> Read <a href={reviewsLink} title={productName}>{ productName } reviews</a>.</span>
            )}
          </strong>
        </SchemaTag>
      </div>
    )
  }
}

ProductReviews.propTypes = {
  productData: object,
  functionParams: array,
  id: string,
  maxReviews: number,
  noSchemaMarkup: bool,
  pageData: object
}

ProductReviews.defaultProps = {
  maxReviews: 5,
  noSchemaMarkup: false,
  productData: { }
}

export default ProductReviews



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/specificProduct/productReviews.jsx